module.exports = __webpack_public_path__ + "static/img/展示1.6424cf96.png";